import { Button } from '@material-ui/core'

import Cloud from './artwork/Cloud'
import MountainForeground, {
  Background as MountainBackground,
  BackgroundSecondary as MountainBackgroundSecondary,
} from './artwork/Mountains'
import ScoirWave from './artwork/ScoirWave'
import Shark from './artwork/Shark'
import './index.scss'

type Props = {
  onGoHome: () => void
}

const FourOhFour = ({ onGoHome }: Props) => (
  <div className="four-oh-four-page-comp">
    <div className="four-oh-four-sky">
      <Cloud className="cloud cloud-1" />
      <Cloud
        className="cloud cloud-2"
        lighter
      />
      <Cloud className="cloud cloud-3" />
      <Cloud
        className="cloud cloud-4"
        lighter
      />
      <div className="four-oh-four-status">
        4
        <span className="four-oh-four-sun">
          <div className="four-oh-four-rays">
            {[...Array(9)].map((_, i) => (
              <div key={i} />
            ))}
          </div>
        </span>
        4
      </div>
      <div className="four-oh-four-text">You seem to have gotten lost, time for you to find your way.</div>
    </div>
    <div className="four-oh-four-action">
      <Button
        variant="outlined"
        color="primary"
        onClick={onGoHome}
      >
        Go Home
      </Button>
    </div>
    <div className="four-oh-four-land">
      <MountainBackgroundSecondary className="mountain-background-secondary" />
      <MountainBackground className="mountain-background" />
      <MountainForeground className="mountain-foreground" />
    </div>
    <div className="four-oh-four-sea">
      <ScoirWave className="scoir-wave" />
      <Shark className="shark shark-1" />
      <Shark
        className="shark shark-2"
        reversed
      />
    </div>
  </div>
)

export default FourOhFour
